<app-user-menu [orgId]="orgId"></app-user-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="offset-sm-2 col-sm-8 col-12">
                    <div class="card border-color-primary">
                        <div class="card-body">
                            <div class="row">
                                <div class="col text-start">
                                    <div class="form-group m-0">
                                        <label
                                            [ngClass]="{'text-success': counterInformations.closed === 0, 'text-danger': counterInformations.closed === 1}">
                                            <strong>{{(counterInformations.closed === 0 ? 'USER.COUNTER.open': 'USER.COUNTER.closed') | translate}}</strong>
                                        </label>
                                        <div class="pt-1 custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" id="statusSwitch"
                                                [checked]="counterInformations.closed === 0"
                                                (change)="onOrganizationCloseStatusChange($event)">
                                            <label class="custom-control-label" for="statusSwitch"></label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col text-center" *ngIf="organization?.id === 229 || organization?.id === 230">
                                  <div class="form-group m-0">
                                    <label
                                      [ngClass]="{'text-success': counterInformations.blocked === 0, 'text-danger': counterInformations.blocked === 1}">
                                      <strong>{{(counterInformations.blocked === 0 ? 'USER.COUNTER.unblocked': 'USER.COUNTER.blocked') | translate}}</strong>
                                    </label>
                                    <div class="pt-1 custom-control custom-switch">
                                      <input type="checkbox" class="custom-control-input" id="blockedSwitch"
                                             [checked]="counterInformations.blocked === 1"
                                             (change)="onOrganizationBlockStatusChange($event)">
                                      <label class="custom-control-label" for="blockedSwitch"></label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col text-end">
                                    <div class="form-group m-0">
                                        <label style="display: block;"><strong
                                                class="text-uppercase">{{'USER.COUNTER.max' | translate}}</strong></label>
                                        <button type="button" class="btn btn-primary btn-sm"
                                            (click)="onMaxButtonClick()">
                                            <span class="badge badge-light">
                                                {{counterInformations?.maxAllowedPersons}}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="counterInformations.maxAllowedPersons <= 0">
                                <div class="col text-center">
                                    <strong class="mt-1">
                                        {{'USER.COUNTER.missingMaxValue' | translate}}
                                    </strong>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-center">
                                    <h1 class="display-1">
                                        {{counterInformations?.currentPeopleAmount}}
                                    </h1>
                                    <span class="text-success">
                                        <span id="remaining-free-places"
                                            data-max-value="0">{{(counterInformations?.maxAllowedPersons - counterInformations?.currentPeopleAmount)}}
                                        </span> {{'USER.COUNTER.remaining' | translate}} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<nav class="navbar fixed-bottom">
    <div class="container">
        <div class="row" style="width: 100%; margin: 0 auto;">
            <div class="col">
                <ul class="list-group list-group-horizontal" style="width: 100%;">
                    <a class="list-group-item list-group-item-action flex-fill text-center border-color-primary background-color-primary color-white action-button action-button-border"
                        [ngClass]="{'disabled': counterInformations.maxAllowedPersons <= 0}"
                        (click)="onCounterActionButtonClick('minus')">
                        <fa-icon [icon]="icons['faMinus']" style="font-size: 20px;"></fa-icon>
                        {{'USER.COUNTER.outgoing' | translate}}
                    </a>
                    <a class="list-group-item list-group-item-action flex-fill text-center border-color-primary background-color-primary color-white action-button action-button-border"
                        [ngClass]="{'disabled': counterInformations.maxAllowedPersons <= 0}"
                        (click)="onCounterActionButtonClick('edit')">
                        <fa-icon [icon]="icons['faEdit']" style="font-size: 20px;"></fa-icon>
                    </a>
                    <a class="list-group-item list-group-item-action flex-fill text-center border-color-primary background-color-primary color-white action-button"
                        [ngClass]="{'disabled': counterInformations.maxAllowedPersons <= 0}"
                        (click)="onCounterActionButtonClick('plus')">
                        <fa-icon [icon]="icons['faPlus']" style="font-size: 20px;"></fa-icon>
                        {{'USER.COUNTER.ingoing' | translate}}
                    </a>
                </ul>
            </div>
        </div>
    </div>
</nav>
<ng-template #setMaxModal let-modal>
    <div class="modal-body">
        <div class="form-group">
            <label>{{'USER.COUNTER.MAXMODAL.title' | translate}}</label>
            <input type="number" min="1" class="form-control form-control-sm" ngModel #maxAmountInput required />
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-success" [disabled]="maxAmountInput.value * 1 < 0"
            (click)="modal.close(maxAmountInput.value)">{{'GENERAL.save' | translate}}</button>
    </div>
</ng-template>

<ng-template #setActualNumberModal let-modal>
    <div class="modal-body">
        <div class="form-group">
            <label>{{'USER.COUNTER.ACTUALMODAL.title' | translate}}</label>
            <input type="number" min="0" class="form-control form-control-sm" ngModel #currentAmountInput required />
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-success"
            [disabled]="currentAmountInput.value * 1 < 0 || currentAmountInput.value == ''"
            (click)="modal.close(currentAmountInput.value)">{{'GENERAL.save' | translate}}</button>
    </div>
</ng-template>
